import { useEffect, useState } from "react";
import useSize from "../../useSize/useSize";

import moment from "moment";
import Backend from "../../../Backend/Backend";
import toast from "react-hot-toast";

import Filter from "./Filter/Filter";

import TotalCard from "./TotalCard/TotalCard";

import Loading from "../../Loading/Loading";

import NotFound from "../../NotFound/NotFound";

import Menu from "./Menu/Menu";
import InterestBillCard from "./InterestBillCard";

const backend = await new Backend().init();

export default function InterestBill(props) {
  const user_id = props.user_id;

  const windowSize = useSize();

  const [loading, setLoading] = useState(false);

  const [interest, setInterest] = useState([]);

  const [interestamount, setInterestAmount] = useState("");
  const [depositinterestamount, setDepositInterestAmount] = useState("");

  const [date_start, setDate_Start] = useState(moment().startOf("week"));
  const [date_end, setDate_End] = useState(moment().endOf("week"));

  useEffect(() => {
    loadUserInterest();
  }, []);

  const loadUserInterest = (a, b) => {
    setDate_Start(a);
    setDate_End(b);

    setLoading(true);
    let data = {
      server: localStorage.getItem("server"),
      id: localStorage.getItem("id"),
      username: localStorage.getItem("username"),
      token: localStorage.getItem("token"),

      start: a === undefined ? date_start : a,
      end: b === undefined ? date_end : b,
      user_id: user_id,
    };

    backend.interest_bill(data).then((r) => {
      setLoading(false);
      if (r.error == "False") {
        setInterest(r.interest);
        setInterestAmount(r.interest_amount);
        setDepositInterestAmount(r.deposit_interest_amt);
      } else {
        toast.error(r.message);
      }
    });
  };

  const containerHeight = windowSize[1] - 170;
  const listHeight = windowSize[1] - 330;

  return (
    <div style={{ width: windowSize[0] - 100, height: containerHeight }}>
      <Filter interest={loadUserInterest} />

      <TotalCard
        interestamount={interestamount}
        depositinterestamount={depositinterestamount}
      />

      <Menu />

      <div
        style={{
          height: listHeight,
          display: "flex",
          flexDirection: "column",
        }}
      >
        {loading ? (
          <div className="loadingContainer">
            <Loading height={listHeight} />
          </div>
        ) : interest.length > 0 ? (
          <div style={{ height: listHeight, overflowY: "scroll" }}>
            {interest.map((item) => (
              <InterestBillCard key={item.id} item={item} />
            ))}
          </div>
        ) : (
          <NotFound
            height={listHeight}
            title="Nothing here"
            subtext="No Interest Bill Found."
          />
        )}
      </div>
    </div>
  );
}
